import { render, staticRenderFns } from "./InvPF.vue?vue&type=template&id=ae2eb0ea"
import script from "./InvPF.vue?vue&type=script&lang=js"
export * from "./InvPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports